import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const defaults = {
  contact_email: "president.brussel@be.elsa.org",
  contact_address: "Pleinlaan 2, 1050 Elsene, Brussel",
  membership_recipient: "humanresources.brussel@be.elsa.org",
  partner_emails: "president.brussel@be.elsa.org, publicrelations.brussel@be.elsa.org",
  hero_title_line1: "Recht in",
  hero_title_line2: "beweging.",
  hero_subtitle: "Dé studentenorganisatie voor rechtenstudenten in Brussel. Door studenten, voor studenten.",
  intro_text: "ELSA Brussel verbindt ambitieuze rechtenstudenten met de juridische wereld — via events, competities en een internationaal netwerk dat verder reikt dan de collegebanken.",
  instagram_url: "https://instagram.com/elsabrussels",
  linkedin_url: "",
};

const SiteConfigContext = createContext({ config: defaults, refresh: () => {} });

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(defaults);

  const refresh = () =>
    api
      .get("/config")
      .then((r) => setConfig({ ...defaults, ...r.data }))
      .catch(() => {});

  useEffect(() => {
    refresh();
  }, []);

  return <SiteConfigContext.Provider value={{ config, refresh }}>{children}</SiteConfigContext.Provider>;
};

export const useSiteConfig = () => useContext(SiteConfigContext);
